import { Asset as _Asset } from './asset';
import { AssetContextMenu } from './asset.context-menu';
import { AssetImage } from './asset.image';
import { AssetLabel } from './asset.label';

const Asset = Object.assign(_Asset, {
  Image: AssetImage,
  ContextMenu: AssetContextMenu,
  Label: AssetLabel,
});

export * from './asset.context-provider';
export type { AssetImageProps } from './asset.image';
export { Asset };
export { AssetDraggable } from './asset.draggable';
export { AssetDraggableWithHandle } from './asset.handle-draggable';
export type { AssetDraggableProps, AssetProps } from './types';
